import api from './api';

/**
 * 예외처리 처리자 마스터 (IPT-613).
 *
 * DLP·NAC·유해차단 예외처리 폼이 같은 목록을 쓴다. 담당자가 바뀌면 관리 화면에서 고친다.
 */
export interface ExceptionActor {
  id: number;
  name: string;
  sortOrder: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface ExceptionActorInput {
  name?: string;
  sortOrder?: number;
  isActive?: boolean;
}

export const exceptionActorService = {
  /** 선택 목록. includeInactive면 사용 안 함까지(관리 화면) */
  getAll: async (includeInactive = false): Promise<ExceptionActor[]> => {
    const res = await api.get('/exception-actors', {
      params: includeInactive ? { includeInactive: 'true' } : undefined,
    });
    return res.data;
  },

  create: async (input: ExceptionActorInput): Promise<ExceptionActor> => {
    const res = await api.post('/exception-actors', input);
    return res.data;
  },

  update: async (id: number, input: ExceptionActorInput): Promise<ExceptionActor> => {
    const res = await api.patch(`/exception-actors/${id}`, input);
    return res.data;
  },

  remove: async (id: number): Promise<{ deleted: boolean; name: string }> => {
    const res = await api.delete(`/exception-actors/${id}`);
    return res.data;
  },
};
